import WedgesShaft from './WedgesShaft';

export default WedgesShaft;
